/* --------------------------------------------------------------------------------------
   reports.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const reportsComponent  = {
    template: require('./reports.html'),
    controller: 'reportsCtrl',
    controllerAs: 'vm',
    bindings: {
      back: '&',
      next: '&'
    }
}

export class reportsCtrl {
    /*@ngInject*/
  constructor (commonService, dataService, appService, resultsService, $state, $scope, $filter, $q, $timeout) {
    this.commonService = commonService
    this.dataService = dataService
    this.appService = appService
		this.resultsService = resultsService
		this.$state = $state
		this.$scope = $scope
    this.$filter = $filter
		this.$q = $q
    this.$timeout = $timeout
  }
  $onInit () {
    this.commonService.setDefaultBackground();
		this.height = this.commonService.getScreenHeight() < 481 ? "280" : "410"
		this.width = this.commonService.getScreenWidth() > 801? "942" : "760"
    let preferences = this.resultsService.loadPreferences()
		this.submitAction = preferences.action? preferences.action : 'print'
    this.dataService.GetReports(this.appService.classId, this.appService.testId).then((result) => {
      this.items = this.$filter('orderBy')(result, 'Name')
			if (!this.items.length)
				this.noreports = true
      this.items.forEach(item => {
        item.selected = (preferences.reports && preferences.reports.includes(item.Name.substring(0,3)))
      })
      this.checkSelected()
		})
    .catch(error => {
      this.appService.handleError(error)
        .then(result => {this.error = result})
    })

    this.className = this.appService.className
    this.testName = this.appService.testName
  }
	selectFormat(item) {
		this.submitAction = item.value
		this.$scope.$apply()
	}
	checkSelected() {
		let selected = this.items.find(item => item.selected)
    new Set(['#btnSubmitPrint','#btnSubmitEmail','#btnSubmitBoth']).forEach(item => {
      angular.element(item).xrxbutton({disabled: !(selected)})
    })
	}
  submit () {
		this.printing = true
    let selectedReports = this.items.filter(item => item.selected)
		this.appService.selectedReportIds = selectedReports.map(item => item.ID)
    let selectedReportNames = selectedReports.map(item => item.Name)
    this.resultsService.savePreferences(this.submitAction, selectedReportNames)
    return this.resultsService.sendReports(this.submitAction)
      .then(result => this.submitFinished())
      .catch(error => {
        this.printing = false
        this.appService.handleError(error)
          .then(result => {this.error = result})
      })
  }
  submitFinished() {
    this.$timeout(() => {
      this.printing = false
      this.back()
    })
  }
  errorClosed() {
    return this.appService.errorClosed(this.error)
  }
}



// WEBPACK FOOTER //
// ./src/app/results/components/reports.component.js